import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest
} from '@angular/common/http';
import {inject} from '@angular/core';
import {BehaviorSubject, from, Observable, throwError} from 'rxjs';
import {catchError, filter, switchMap, take} from 'rxjs/operators';

import {LoginService} from '../service/login.service';
import {environment} from '../../../environments/environment';
import {v4 as uuidv4} from 'uuid';
import {TokenResponse} from 'angular-oauth2-oidc';


let isRefreshing = false;
const refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

function startWithAny(url: string, ...strings: string[]): boolean {
    return strings.some(s => url.startsWith(s));
}

export const AuthInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
    const loginService = inject(LoginService);

    if (request.headers.get('Authorization') || shouldSkipInterceptor(request.url)) {
        return next(request);
    }
    const token = loginService.keycloackgetToken();

    if (token) {
        const authRequest = addTokenToRequest(request, token);
        return next(authRequest).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return handle401Error(authRequest, next, loginService);
                }
                return throwError(() => error);
            })
        );
    } else {
        return next(request);
    }
};


function shouldSkipInterceptor(url: string): boolean {
    return startWithAny(url,
        'https://viacep.com.br/ws/',
        'https://www.receitaws.com.br/v1/',
        'https://nominatim.openstreetmap.org/search',
        'https://maps.googleapis.com/maps/api/geocode/json',
        environment.keycloak.url
    );
}


function addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
        setHeaders: {
            'Authorization': 'Bearer ' + token,
            'PDSA-Trace-Id': uuidv4()
        }
    });
}

function handle401Error(request: HttpRequest<any>, next: HttpHandlerFn, loginService: LoginService): Observable<HttpEvent<any>> {
    if (!isRefreshing) {
        isRefreshing = true;
        refreshTokenSubject.next(null);
        return from(loginService.keycloackRefreshToken()).pipe(
            switchMap((tokens: TokenResponse) => {
                isRefreshing = false;
                const newAccessToken = tokens.access_token;
                refreshTokenSubject.next(newAccessToken);
                return next(addTokenToRequest(request, newAccessToken));
            }),
            catchError((err) => {
                isRefreshing = false;
                loginService.logout();
                return throwError(() => err);
            })
        );
    } else {
        return refreshTokenSubject.pipe(
            filter(token => token != null),
            take(1),
            switchMap(newAccessToken => next(addTokenToRequest(request, newAccessToken)))
        );
    }
}
